import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "../../api/axios";
import { openErrorMessage } from "../slices/toastSlice";

export const sendEmail = createAsyncThunk(
  "message/sendEmailToRecipient",
  /**
   *
   * @param {Object} data
   * @param {String} data.recipentId
   * @param {String} data.chatDialogId
   */
  async (data, { rejectWithValue }) => {
    try {
      // const response = await axios.post("/reviews/seller", data);
      const response = await axios.post("/message/email", data);
      return response.data.review;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);
